export enum Role {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  PROJECT_MANAGER = 'project_manager',
  PROJECT_ASSIGNEE = 'project_assignee',
  SUPERVISOR = 'associate',
  ASSOCIATE = 'associate',
}
